import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-control-bar',
  standalone: false,
  templateUrl: './control-bar.component.html',
  styleUrls: ['./control-bar.component.scss']

})
export class ControlBarComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}